<template>
  <select2
    v-model="internalValue"
    class="form-control"
    :data-placeholder="placeholder"
  >
    <option :value="null"></option>
    <option v-for="o in options" :key="o[valueField]" :value="o[valueField]">
      {{ o[labelField] || o.name }}
    </option>
  </select2>
</template>

<script>
import { practitionerHttpService } from "../../../app/practitioner-portal/store/practitioner-http-service";

export default {
  name: "GenericAdminFilter",
  props: {
    value: {
      type: [Number, String, null],
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    endpoint: {
      type: String,
      required: true,
    },
    baseUrl: {
      type: String,
      default: "/api/internal/admin/filters",
    },
    labelField: {
      type: String,
      default: "display_name",
    },
    valueField: {
      type: String,
      default: "id",
    },
  },
  data() {
    return {
      options: [],
      internalValue: this.value,
    };
  },
  watch: {
    value(v) {
      this.internalValue = v;
    },
    internalValue(v) {
      this.$emit("input", v);
    },
  },
  created() {
    practitionerHttpService
      .get(`${this.baseUrl}/${this.endpoint}`)
      .then((res) => {
        this.options = Array.isArray(res.data) ? res.data : [];
      })
      .catch(() => {
        this.options = [];
      });
  },
};
</script>
